module.exports = __webpack_public_path__ + "static/img/190329-paternity-embryo.2658855.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/190329-paternity-embryo.jpg
// module id = AUhW
// module chunks = 0